import { ExistingProvider, inject, Injectable } from '@angular/core';
import { environment } from '@portal/env';
import { MapApiService } from 'src/app/services/api/map-api.service';
import { AosMapConfig, AosMapConfigToken, FocusAreaDataSource } from '@portal/shared/components/map/map.types';

@Injectable({ providedIn: 'root' })
export class DevicesMapConfig implements AosMapConfig {
  readonly #mapApi = inject(MapApiService);

  readonly tileEndpoint = environment.map.mapDevicesGeoUrl;
  readonly itemsCountFieldName = 'deviceCount';
  readonly focusAreaDataSource: FocusAreaDataSource = {
    get: payload => this.#mapApi.getDevicesFocusArea(payload)
  };
}

export const devicesMapConfigProvider: ExistingProvider = {
  provide: AosMapConfigToken,
  useExisting: DevicesMapConfig
};
